// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"3e080b57","513":"5b1d3192","703":"9aec231d"}[chunkId] + ".chunk.js";
};